interface CheckIconProps {
  width: number;
  height: number;
}

export const CheckIcon = ({ width, height }: CheckIconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={16}
      viewBox="0 0 17 16"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.0874 3.58472C12.3779 3.81105 12.3043 4.211 12.0874 4.47135L5.97628 11.8047C5.75932 12.065 5.40756 12.065 5.19061 11.8047L2.41283 8.47135C2.19587 8.211 2.15598 7.81835 2.41284 7.60878C2.66965 7.39919 3.13176 7.46581 3.34872 7.72616L5.58344 10.3905L11.1706 3.76071C11.3876 3.50036 11.7969 3.35833 12.0874 3.58472Z"
        fill="#FCFDFD"
      />
    </svg>
  );
};
